import styled from "styled-components";
import { getColor } from "~/helpers/style";

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(8, 14, 40, 0.55);
  padding: 24px;
`;

export const ModalCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  width: min(531px, 100%);
  padding: 40px;
  border-radius: 24px;
  background: #ffffff;
  text-align: center;
`;

export const IconContainer = styled.div<{ $background: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 140px;
  height: 140px;
  border-radius: 50%;
  background: ${({ $background }) => $background};
  padding: 0 38px;
`;

export const Title = styled.h2`
  margin: 10px 0 0;
  color: ${getColor("text")};
  font-size: 24px;
  font-weight: 700;
  line-height: 1.3;
`;

export const Description = styled.p`
  margin: 0 0 14px;
  color: ${getColor("textSecondary")};
  font-size: 16px;
  line-height: 1.5;
  max-width: 420px;
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

export const PrimaryButton = styled.button`
  width: 100%;
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  background: ${getColor("primary")};
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: filter 0.1s ease-in-out;

  &:hover {
    filter: brightness(0.95);
  }
`;

export const SecondaryButton = styled.button`
  width: 100%;
  padding: 12px 24px;
  border: 1px solid ${getColor("border")};
  border-radius: 8px;
  background: #ffffff;
  color: ${getColor("text")};
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: filter 0.1s ease-in-out;

  &:hover {
    filter: brightness(0.98);
  }
`;
